import { PushConfig } from './push/PushConfig';
import { RuntimeConfig } from './RuntimeConfig';
import { StartupConfig } from './StartupConfig';
import { ThemingConfig } from './ThemingConfig';
import * as InternalTypes from '../common/InternalTypes';

export class ConfigFactory {
	static createStartupConfig(startupConfig: InternalTypes.StartupConfig) {
		return new StartupConfig(startupConfig);
	}

	static createRuntimeConfig(runtimeConfig?: InternalTypes.RuntimeConfig) {
		return new RuntimeConfig(runtimeConfig);
	}

	static createPushConfig(startupConfig: InternalTypes.StartupConfig, pushConfig?: InternalTypes.PxPushConfig) {
		return new PushConfig(startupConfig, pushConfig);
	}

	static createThemingConfig(themingConfig: InternalTypes.ThemingConfig) {
		return new ThemingConfig(themingConfig);
	}
}
